import { render } from "./DetailGift.vue?vue&type=template&id=9224aad0&scoped=true"
import script from "./DetailGift.vue?vue&type=script&lang=js"
export * from "./DetailGift.vue?vue&type=script&lang=js"

import "./DetailGift.vue?vue&type=style&index=0&id=9224aad0&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9224aad0"]])

export default __exports__